import { FC, PropsWithChildren } from "react";

import { RideInvestigationPlaybackContext } from "./ride-investigation-playback.context";
import { useRideInvestigationPlaybackValue } from "./use-ride-investigation-playback-value";

/**
 * Wraps the whole live-map page so the map marker, the info panel and the transport bar all read one
 * playhead. All playback state lives in `useRideInvestigationPlaybackValue`; passing `children` straight
 * through keeps the map subtree from re-rendering on playback state ticks.
 */
export const RideInvestigationPlaybackProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const value = useRideInvestigationPlaybackValue();

  return (
    <RideInvestigationPlaybackContext.Provider value={value}>
      {children}
    </RideInvestigationPlaybackContext.Provider>
  );
};
